<template>
  <QCard :class="{ 'full-width': $q.screen.lt.md }">
    <QForm @submit="$emit('submit:pin')" class="column q-pa-lg q-ma-md">
      <PageHeader class="q-pb-md">
        <div class="col-12 q-mb-xs">
          <HeaderBackBtn @click="$emit('back', $event)" />
        </div>
        <h4 class="col-12">Verify It's You</h4>
      </PageHeader>
      <div class="col">
        <p class="text-body1">
          We've sent an email verification code to your email{{
            email ? ` ${email}` : ''
          }}.
        </p>
      </div>
      <div class="col">
        <p class="text-body1 q-mt-sm">
          Enter the code from the email in the field below.
        </p>
      </div>
      <div class="col-grow column items-center">
        <PinInput
          class="q-mt-lg"
          :lock="lock"
          :value="pin"
          :disable="disable"
          :error="errors.pin.$error"
          @input="$emit('update:pin', $event)"
        />
        <QSpinner v-if="loading" class="q-mt-lg" size="md" color="primary" />
      </div>
      <span class="text-warning q-mt-lg" v-if="!loading">
        {{ errorMessage }}
      </span>
      <div class="row justify-center q-mt-lg">
        <QBtn
          label="Resend Code"
          color="primary"
          no-caps
          flat
          @click="$emit('resend:email')"
        />
      </div>
    </QForm>
  </QCard>
</template>

<script>
import { QForm, QSpinner, QCard, QBtn } from 'quasar';

export default {
  name: 'SignUpPin',
  props: {
    email: String,
    errors: {
      type: Object,
      default: () => ({})
    },
    errorMessage: String,
    pin: undefined,
    disable: Boolean,
    loading: Boolean,
    lock: Boolean
  },
  components: {
    QForm,
    QCard,
    QSpinner,
    QBtn,
    HeaderBackBtn: () => import('../../atom/header-back-btn'),
    PageHeader: () => import('../../atom/page-header'),
    PinInput: () => import('../../atom/pin-input')
  }
};
</script>
